import React from "react";
import { node } from "prop-types";
import { Box, Container } from "@mui/material";

const AppPageContentWrapper = ({ children }) => (
  <Box
    component="section"
    sx={{
      alignContent: "center",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      my: 4,
      width: "100%",
      maxWidth: "100%",
      overflowX: "hidden",
      boxSizing: "border-box",
    }}
  >
    <Container
      sx={{
        width: "100%",
        maxWidth: "100%",
        paddingLeft: { xs: 2, sm: 3 },
        paddingRight: { xs: 2, sm: 3 },
        boxSizing: "border-box",
      }}
    >
      {children}
    </Container>
  </Box>
);

AppPageContentWrapper.propTypes = {
  children: node.isRequired,
};

export default AppPageContentWrapper;
